import { IEngagementsRevenueItem } from 'pages/Dashboard/Dashboard.models';

import {
  GET_ENGAGEMENTS_REVENUE_REQUEST,
  GET_ENGAGEMENTS_REVENUE_SUCCESS,
  GET_ENGAGEMENTS_REVENUE_FAILURE,
} from './actionsTypes';

interface IGetEngagementsRevenueState {
  data: IEngagementsRevenueItem[];
  isLoading: boolean;
  error: object;
}

const initialState: IGetEngagementsRevenueState = {
  isLoading: false,
  data: [],
  error: {},
};

const getEngagementsRevenueReducer = (state = initialState, {
  type, data, error,
}) => {
  if (type === GET_ENGAGEMENTS_REVENUE_REQUEST) {
    return {
      ...state,
      isLoading: true,
    };
  }

  if (type === GET_ENGAGEMENTS_REVENUE_SUCCESS) {
    return {
      ...state,
      data,
      isLoading: false,
    };
  }

  if (type === GET_ENGAGEMENTS_REVENUE_FAILURE) {
    return {
      ...state,
      isLoading: false,
      data: [],
      error,
    };
  }

  return state;
};
export default getEngagementsRevenueReducer;
